import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import httpService from '../api/httpService';
import { useAuth } from '../contexts/AuthContext';

function MandatoryInfo() {
    const navigate = useNavigate();
    const { userDetails } = useAuth();
    const isAdmin = userDetails?.admin === true || userDetails?.admin === 1;
    const [countries, setCountries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    // useEffect(() => {
    //     const fetchCountriesWithSetups = async () => {
    //         setLoading(true);
    //         setError('');
    //         try {
    //             const orgId = userDetails?.orgId ?? userDetails?.OrgId ?? null;
    //             const isAdmin = userDetails?.admin === true;
    //             const url = !isAdmin && orgId != null
    //                 ? `/Country/WithSetups?orgId=${orgId}`
    //                 : '/Country/WithSetups';

    //             const result = await httpService.getData(url);
    //             if (result?.isSuccess && result?.retObject) {
    //                 setCountries(Array.isArray(result.retObject) ? result.retObject : []);
    //             } else {
    //                 setCountries([]);
    //             }
    //         } catch (e) {
    //             console.error('Failed to load countries with setups', e);
    //             setError('Failed to load data.');
    //             setCountries([]);
    //         } finally {
    //             setLoading(false);
    //         }
    //     };
    //     fetchCountriesWithSetups();
    // }, []);

// <----- fetching details for organization page ----->   
    const fetchData = async (searchParams = {}, pageNumber = 1) => {
        setLoading(true);
        setError('');
        try{
            const params = {
                pageNumber: pageNumber,
                pageSize: 10,
                ...searchParams
            };
            const orgId = userDetails?.orgId ?? userDetails?.OrgId ?? null;
            const endpoint = !isAdmin && orgId != null
                ? `/Country/WithSetups?orgId=${orgId}`
                : '/Country/WithSetups';
            const result = await httpService.getData(endpoint, params, true);
            if (result?.isSuccess && result?.retObject) {
                setCountries(Array.isArray(result.retObject.countries) ? result.retObject.countries : []);
                setCurrentPage(result.retObject.currentPage);
                setTotalPages(result.retObject.totalPages);
            } else {
                setCountries([]);
            }    
        }catch(err){
            console.log(err.message);
            setError(err.message);
        }finally {
            setLoading(false);
        }
    };

    useEffect(() =>{
        fetchData();
    },[]);

    // <------- Logic for pagination ------->  
    const handleNext = () => {
        if (currentPage < totalPages) {
            fetchData({}, currentPage + 1);
        }
    };

    const handleFirst = () => {
        if (currentPage > 1) {
            fetchData({}, 1);
        }
    };

    const handleLast = () => {
        if (currentPage < totalPages) {
            fetchData({}, totalPages);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            fetchData({}, currentPage - 1);
        }
    };

    return (
        <div className="app-content p-4">
            <div className="container-fluid mt-4">
                <div className="card custom-card create-user-card">
                    <div className="card-header justify-content-between">
                        <div className="card-title">Setups</div>
                        <ul className='custom_btns'>
                            {isAdmin && (
                            <li>
                                <Link to="/settings" type="button" className="btn btn-outline-secondary btn-sm btn-wave">
                                    <i className="fas fa-plus fa-sm side-menu__icon me-1 align-middle d-inline-block"></i>Add New SetUp
                                </Link>
                            </li>
                            )}
                        </ul>
                    </div>
                    <div className="card-body">
                        {error && <div className="alert alert-warning mb-3">{error}</div>}
                        <div className='row pagination'>
                            <div className='col-md-12 text-end mb-3'>                                              
                                <span> Page {currentPage} of {totalPages} </span>                                              
                                <span className='btn btn-icon btn-sm bg-pagi-transparent'
                                    onClick={handleFirst} 
                                    disabled={currentPage === totalPages}
                                >
                                        <i className="fas fa-angles-left"></i>
                                </span>
                                <span className='btn btn-icon btn-sm bg-pagi-transparent'
                                    onClick={handlePrevious} 
                                    disabled={currentPage === 1}                                                   
                                >
                                    <i className="fas fa-chevron-left"></i>
                                </span>                                                
                                <span className='btn btn-icon btn-sm bg-pagi-transparent'
                                    onClick={handleNext} 
                                    disabled={currentPage === totalPages}
                                    >
                                        <i className="fas fa-chevron-right"></i>
                                </span>
                                <span className='btn btn-icon btn-sm bg-pagi-transparent'
                                    onClick={handleLast} 
                                    disabled={currentPage === totalPages}
                                    >
                                        <i className="fas fa-angles-right"></i>
                                </span>                                               
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table id="dataTable" className='table table-hover border table-bordered'>
                                <thead>
                                    <tr>
                                        <th>Country</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="2" className="text-center py-3">
                                                <span className="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                                                Loading...
                                            </td>
                                        </tr>
                                    ) : countries.length === 0 ? (
                                        <tr>
                                            <td colSpan="2" className="text-center text-muted">No countries with setups found.</td>
                                        </tr>
                                    ) : (
                                        countries.map((c) => (
                                            <tr key={c.countryId}>
                                                <td>{c.countryName || c.countryCode || c.countryId}</td>
                                                <td>
                                                    <span className="action-icon btn-icon btn-sm btn-success-light me-3" onClick={() => navigate(`/settings/${c.countryId}`)} title="Edit setup">
                                                        <i className="fa-regular fa-pen-to-square"></i>
                                                    </span>
                                                    {isAdmin && (
                                                    <span className="action-icon btn-icon btn-sm btn-danger-light" title="Remove">
                                                        <i className="fa-regular fa-trash-can"></i>
                                                    </span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MandatoryInfo;